import { Injectable, OnInit } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newBody = req.body;

    if (req.body && typeof req.body === 'object') {
      newBody = this.trimStrings(req.body);
    }

    const newReq = req.clone({
      body: newBody,
    });

    return next.handle(newReq);
  }

  private trimStrings(input: any): any {
    if (!input) {
      return input;
    }

    if (typeof input === 'string') {
      input = input.trim();
    }

    if (Array.isArray(input)) {
      input = input.map(item => this.trimStrings(item));
    }

    if (typeof input === 'object') {
      for (const key in input) {
        try {
          input[key] = this.trimStrings(input[key]);
        } catch (e) {
          continue;
        }
      }
    }

    return input;
  }
}
